import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { About } from "./components/About";
import { Account } from "./components/Account";
import { Accounts } from "./components/Accounts";
import { App } from "./App";
import { BrowserRouter, Route, Routes } from "react-router";
import { AppChat } from "./components/AppChat";
import { Chat } from "./components/Chat";
import { Chats } from "./components/Chats";
import { ConfirmDialog } from "./components/ConfirmDialog";
import { Home } from "./components/Home";
import { Login } from "./components/Login";
import { Register } from "./components/Register";
import { NuqsAdapter } from "nuqs/adapters/react-router/v7";
import { SearchMessages } from "./components/SearchMessages";
import { Settings } from "./components/Settings";
import { ThemeProvider as MuiThemeProvider, createTheme } from "@mui/material";
import "./ext";
import "~build/console";

const muiTheme = createTheme({
	cssVariables: { nativeColor: true },
	palette: {
		primary: {
			main: getComputedStyle(document.documentElement)
				.getPropertyValue("--color-primary-dark")
				.trim(),
		},
		secondary: {
			main: getComputedStyle(document.documentElement)
				.getPropertyValue("--color-secondary-dark")
				.trim(),
		},
	},
});

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
	<StrictMode>
		<MuiThemeProvider theme={muiTheme}>
			<ConfirmDialog />
			<div id="chat-messages-aria-live" className="sr-only" aria-live="polite" aria-atomic="true" />
			<NuqsAdapter defaultOptions={{ shallow: false }}>
				<BrowserRouter>
					<Routes>
						<Route element={<App />}>
							<Route index element={<Home />} />
							<Route path="login" element={<Login />} />
							<Route path="register" element={<Register />} />
							<Route path="accounts" element={<Accounts />}>
								<Route path=":accountId" element={<Chats />}>
									<Route index element={<Account />} />
									<Route path="search" element={<SearchMessages />} />
									<Route path="chats">
										<Route index element={<div />} />
										<Route path=":chatId/details?" element={<Chat />} />
									</Route>
									<Route path="apps">
										<Route index element={<div />} />
										<Route path=":chatId" element={<AppChat />} />
									</Route>
									<Route path="requests">
										<Route index element={<div />} />
										<Route path=":chatId/details?" element={<Chat />} />
									</Route>
								</Route>
							</Route>
							<Route element={<Accounts />}>
								<Route path="about" element={<About />} />
								<Route path="settings" element={<Settings />} />
							</Route>
						</Route>
					</Routes>
				</BrowserRouter>
			</NuqsAdapter>
		</MuiThemeProvider>
	</StrictMode>,
);

if (navigator.serviceWorker) {
	(async () => {
		const reg = await navigator.serviceWorker.ready;
		if (!navigator.serviceWorker.controller) {
			// There is a service worker but it's not attached
			// Force attach
			// Needed at least in Firefox for hard-reload
			reg.active?.postMessage("clientsClaim");
		}
	})();
}
